import { BRAND_LIST, CountryLanguageSwitcher, DistanceUnit } from 'typings'
import * as Typings from '../typings'

const IrelandLocale: Typings.LocaleType = {
  IS_EU: true,
  REGION: Typings.RegionGroupNames.OTHER,
  CODE: 'IE',
  LANGUAGE_CODE: 'en',

  LONG_NAME: 'Ireland',
  SHORT_NAME: 'IE',

  DISPLAY_NAME: 'Ireland (English)',
  DISPLAY_COUNTRY: 'Ireland (English)',

  GEO_COORDINATES: {
    INITIAL_LATITUDE: 53.3575794,
    INITIAL_LONGITUDE: -10.8563878,
    INITIAL_ZOOM: 5,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  AREAS: {
    '1': 'Carlow',
    '2': 'Cavan',
    '3': 'Clare',
    '4': 'Cork',
    '5': 'Donegal',
    '6': 'Dublin',
    '7': 'Galway',
    '8': 'Kerry',
    '9': 'Kildare',
    '10': 'Kilkenny',
    '11': 'Laois',
    '12': 'Leitrim',
    '13': 'Limerick',
    '14': 'Longford',
    '15': 'Louth',
    '16': 'Mayo',
    '17': 'Meath',
    '18': 'Monaghan',
    '19': 'Offaly',
    '20': 'Roscommon',
    '21': 'Sligo',
    '22': 'Tipperary',
    '23': 'Waterford',
    '24': 'Westmeath',
    '25': 'Wexford',
    '26': 'Wicklow',
  },

  HOME_PAGE_URL: 'https://www.uniqlo.com/eu-ie/en/',

  MAP_MOBILE_URL: 'https://map.uniqlo.com/eu-ie/en/',

  CONTACT_US_URL: 'https://faq-eu.uniqlo.com/',
  TERMS_OF_USE_URL:
    'https://faq-eu.uniqlo.com/pkb_Home_UQ_EU?l=en&c=category_uq_eu_dk_se%3ARenew_UQEU_C7_3',
  PRIVACY_POLICY_URL:
    'https://faq-eu.uniqlo.com/pkb_Home_UQ_EU?l=dk&c=category_uq_eu_dk_se%3ARenew_UQEU_C7_2',

  POSTCODE_FORMAT: /^[0-9a-zA-Z]{3} ([0-9a-zA-Z]{4})$/,

  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
  },

  DISTANCE_UNIT: DistanceUnit.KM,

  SHOW_COUNTRY_LANGUAGE_MODAL: {
    [BRAND_LIST.UQ]: CountryLanguageSwitcher.HEADER_SWITCHER_MODAL,
    [BRAND_LIST.GU]: CountryLanguageSwitcher.ALL_DISABLED,
    [BRAND_LIST.PL]: CountryLanguageSwitcher.ALL_DISABLED,
  },

  ONE_TRUST_FOOTER: {
    [BRAND_LIST.UQ]: true,
  },
}

export default IrelandLocale
